import shirt from '../images/shop/black-tshirt.png';
import bag from '../images/shop/chain-bag.png';
import shoes from '../images/shop/sneakers.png';
import hat from '../images/shop/bucket-hat.png';
import glasses from '../images/shop/sunglasses.png';
import backpack from '../images/shop/backpack.png';
import whiteShirt from '../images/shop/white-tshirt.png';
import tote from '../images/shop/canvas-tote.png';
import bracelet from '../images/shop/chain-bracelet.png';
import cap from '../images/shop/black-cap.png';
import crossbody from '../images/shop/crossbody-bag.png';
import wallet from '../images/shop/zip-wallet.png';

// Existing storefront sample catalog. Not live inventory or verified offers.
export const catalog = [
  [1, 'GUCCI', '로고 크루넥 코튼 티셔츠', '의류', 890000, shirt],
  [2, 'GUCCI', 'GG 마틀라세 숄더백', '가방', 2350000, bag],
  [3, 'NIKE', '에어 조던 1 로우 블랙 화이트', '신발', 129000, shoes],
  [4, 'PRADA', '리나일론 버킷햇', '액세서리', 680000, hat],
  [5, 'GENTLE MONSTER', 'MM004 블랙 선글라스', '액세서리', 295000, glasses],
  [6, 'BURBERRY', '체크 백팩', '가방', 1650000, backpack],
  [7, 'AMI', '하트 로고 반팔 티셔츠', '의류', 189000, whiteShirt],
  [8, 'CELINE', '트리옹프 캔버스 토트백', '가방', 1890000, tote],
  [9, 'VIVIENNE WESTWOOD', '미니 바스 릴리프 팔찌', '액세서리', 175000, bracelet],
  [10, 'STONE ISLAND', '로고 패치 볼캡', '액세서리', 195000, cap],
  [11, 'MAISON MARGIELA', '5AC 미니백', '가방', 1290000, crossbody],
  [12, 'BOTTEGA VENETA', '인트레치아토 지퍼 지갑', '액세서리', 720000, wallet],
].map(([id, brand, name, category, price, image]) => ({ id, brand, name, category, price, image }));
export const categories = ['전체', '의류', '가방', '신발', '액세서리'];
export const money = value => Number(value).toLocaleString('ko-KR');

export function formatDate(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}.${m}.${day}`;
  } catch (_) {
    return '';
  }
}

export function isNewArrival(dateStr) {
  if (!dateStr) return false;
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return false;
    const now = new Date();
    const diffHours = (now.getTime() - d.getTime()) / (1000 * 60 * 60);
    return Math.abs(diffHours) <= 24 * 7;
  } catch (_) {
    return false;
  }
}

// 실제로 소개할 상품은 서버(antsmarket.tb_ad_items)에 있다. 위 catalog 는
// 그것이 하나도 없을 때만 쓰는 디자인 예시다. 예시를 실제 상품처럼 보이게
// 두면 "왜 GUCCI 가 뜨냐" 는 말이 계속 나온다.
const SOURCE_LABEL = { coupang: '쿠팡' };

// 가격은 '299,000원' 같은 표시 문자열로 저장된다. 정렬에만 쓰므로 숫자를
// 못 뽑으면 0 으로 둔다. 화면에 0원이라고 찍지는 않는다.
const priceNumber = (value) => {
  const n = Number(String(value ?? '').replace(/[^0-9.]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

export function normalizeAdItem(row) {
  return {
    id: Number(row.id),
    brand: SOURCE_LABEL[row.source] || row.source || '제휴',
    name: row.title,
    category: row.category || '기타',
    price: priceNumber(row.price),
    priceText: row.price || '',
    // 이미지가 없는 행이 많다. 여기서 비워 두고 카드에서 대체 이미지를 쓴다.
    image: row.imageUrl || '',
      // 검증된 추적 링크만 구매 버튼에 사용한다. 원본 주소를 광고로 오인하지 않는다.
      affiliateUrl: row.tracked ? row.url || '' : '',
    description: row.summary || '',
    trendSource: row.trendSource || '',
    author: row.author || '',
    createdAt: row.createdAt || '',
    isAgent: !!row.byAgent,
  };
}

export async function fetchAdProducts() {
  const res = await fetch('/ad/list?limit=100');
  if (!res.ok) throw new Error(`광고 상품 응답 ${res.status}`);
  const body = await res.json();
  const items = Array.isArray(body?.items) ? body.items : [];
  return { products: items.map(normalizeAdItem), disclosure: body?.disclosure || '' };
}

// 분야는 실제 상품에서 뽑는다. 목록에 없는 분야 버튼을 두면 눌러도 0건이다.
export function categoriesOf(products) {
  return ['전체', ...[...new Set(products.map(p => p.category).filter(Boolean))]];
}

export function selectProducts({ query = '', category = '전체', brand = '', sort = 'default', savedOnly = false, saved = [], products = catalog } = {}) {
  const result = products.filter(p => (!query.trim() || `${p.brand} ${p.name} ${p.category} ${p.description || ''}`.toLowerCase().includes(query.trim().toLowerCase()))
    && (category === '전체' || p.category === category) && (!brand || p.brand === brand) && (!savedOnly || saved.includes(p.id)));
  // 원본 배열을 뒤집지 않도록 복사해서 정렬한다.
  return sort === 'low' ? [...result].sort((a, b) => a.price - b.price) : sort === 'high' ? [...result].sort((a, b) => b.price - a.price) : result;
}
